export const TEXT_FIELD_CONST = {
  SIZE: {
    MEDIUM: 'medium',
    SMALL: 'small',
  },
  VARIANT: {
    FILLED: 'filled',
    OUTLINED: 'outlined',
    STANDARD: 'standard',
  },
  TYPE: {
    TEXT: 'text',
    NUMBER: 'number',
    TEL: 'tel',
  },
};



// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomTextField/Constants.js